//
export const debugActivated = localStorage.getItem("debug") === "true"

export const consoleDebug = (message?: any, ...optionalParams: any[]) => {
  if (debugActivated) {
    console.log(message, ...optionalParams)
  }
}

// Cache auth strategy to avoid re-reading URL params on every call
let cachedAuthStrategy: "auth0" | "parent" | null = null

// Function to get current auth strategy.
// Standalone (not embedded) → Auth0. Embedded in the webapp iframe → the
// cookie-proxy "parent" strategy. The legacy Clerk strategy was removed in
// LOCKER-319 (no tenant uses it); the webapp always embeds with
// `?authStrategy=parent`, and the iframe default is now "parent".
export const getAuthStrategy = (): "auth0" | "parent" => {
  // Return cached value if already determined
  if (cachedAuthStrategy !== null) {
    return cachedAuthStrategy
  }

  // Determine strategy on first call
  const isInIframe = window.self !== window.top

  if (!isInIframe) {
    cachedAuthStrategy = "auth0"
  } else {
    cachedAuthStrategy = "parent"
  }

  return cachedAuthStrategy
}
